module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('v-btn', _vm._b({
    attrs: {
      "href": _vm.LINKS.INVITE,
      "target": "_blank"
    }
  }, 'v-btn', _vm.attrs, false), [(_vm.icon) ? _c('v-icon', {
    staticClass: "mr-1",
    attrs: {
      "small": ""
    }
  }, [_vm._v(_vm._s(_vm.icon))]) : _vm._e(), _vm._v("\n    " + _vm._s(_vm.text) + "\n")], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-816e344c","hasScoped":false}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/btns/InviteBtn.vue
// module id = 1487
// module chunks = 9